import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { Alert } from "@material-ui/lab";
import { apiEndpoints, apiPostRequest } from "src/utils/api/api";
import { useParams } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import {  getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const ConfirmAttendanceLink = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState();
  const [infoMessage, setInfoMessage] = useState();
  const { confirmationKey } = useParams();

  useEffect(() => {
    enableGlobalLoader();

    apiPostRequest(
      apiEndpoints.confirmAttendanceLink.path,
      { linkKey: confirmationKey, action: rest.action },
      false
    )
      .then((data) => {
        if (rest.action === "participation") {
          setInfoMessage(
            "Potwierdzenie uczestnictwa w posiedzeniu zostało zarejestrowane"
          );
        } else if (rest.action === "no_participation") {
          setInfoMessage(
            "Potwierdzenie braku uczestnictwa w posiedzeniu zostało zarejestrowane"
          );
        }
        disableGlobalLoader();
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          if (
            error.response.status === 404 &&
            error.response.data.code === "ERROR_ATTENDANCE_CHECKING_NOT_ACTIVE"
          ) {
            setErrorMessage(
              `Zbieranie potwierdzeń uczestnictwa zostało zakończone. W przypadku pytań skontaktuj się z administratorem Portalu KM ${getSystemLabel('programShortcut', globalData.systemInfo)}`
            );
          } else {
            setErrorMessage(
              `Wystąpił błąd podczas potwierdzania uczestnictwa w posiedzeniu. Jeśli problem będzie się powtarzał, skontaktuj się z administratorem Portalu KM ${getSystemLabel('programShortcut', globalData.systemInfo)}`
            );
          }
        } else {
          setErrorMessage(
            `Wystąpił błąd podczas potwierdzania uczestnictwa w posiedzeniu. Jeśli problem będzie się powtarzał, skontaktuj się z administratorem Portalu KM ${getSystemLabel('programShortcut', globalData.systemInfo)}`
          );
        }

        disableGlobalLoader();
      });
    return () => {};
  }, []);

  return (
    <Page
      className={classes.root}
      title="Potwierdzenie uczestnictwa w posiedzeniu"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          {infoMessage || errorMessage ? (
            <Box mb={1}>
              <Typography color="textPrimary" variant="h2">
                Potwierdzenie uczestnictwa w posiedzeniu
              </Typography>
              {errorMessage ? (
                <Alert severity="error" className={classes.massagebox}>
                  {errorMessage}
                </Alert>
              ) : (
                <></>
              )}
              {infoMessage ? (
                <Alert severity="success" className={classes.massagebox}>
                  <div>{infoMessage}</div>
                </Alert>
              ) : (
                <></>
              )}
              <Box my={2}>
                <Button
                  component={RouterLink}
                  to="/logowanie"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Strona logowania
                </Button>
              </Box>
            </Box>
          ) : (
            <></>
          )}
        </Container>
        <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
          <Box display="flex" flexDirection="column">
            <img
              className={classes.img}
              alt="Logo UE stopka"
              src="/static/images/logo_ue_main.jpg"
            />
            <Typography
              variant="caption"
              gutterBottom
              color="textSecondary"
              align="center"
              component="p"
            >
              Aplikacja współfinansowana przez Unię Europejską ze środków
              Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
              Operacyjnego Województwa Podlaskiego na lata 2014-2020
            </Typography>
            <Typography
              color="textPrimary"
              variant="subtitle2"
              align="center"
              component="p"
            >
              2021 © Urząd Marszałkowski Województwa Podlaskiego
            </Typography>
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmAttendanceLink);
